import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

import { Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';

const commonHeadingStyle: FlattenSimpleInterpolation = css`
  font-weight: ${FontWeight.Medium};
  letter-spacing: -0.01em;
  color: ${Color.Black};
`;

export const H1: StyledComponent<'h1'> = styled.h1`
  ${commonHeadingStyle}
  font-size: 60px;
  line-height: 64px;
`;

export const H2: StyledComponent<'h2'> = styled.h2`
  ${commonHeadingStyle}
  font-size: 40px;
  line-height: 44px;
`;

export const H3: StyledComponent<'h3'> = styled.h3`
  ${commonHeadingStyle}
  font-size: 30px;
  line-height: 38px;
`;

export const H4: StyledComponent<'h4'> = styled.h4`
  ${commonHeadingStyle}
  font-size: 22px;
  line-height: 28px;
`;
